import { isArray } from "underscore";
import { IErrorResult } from '../../../../model/common/error/error.model';
import { Exception } from '../../../../model/common/exception';
import { WindowService, IWindowOption } from "../window/window.service";
import { AuthenticationService } from "../authentication.service";
import { MessageService } from "../message.service";

export class HttpService {

	private $http: ng.IHttpService;
	private $translate: ng.translate.ITranslateService;
	private windowService: WindowService;
	private authService: AuthenticationService;
    private msgService: MessageService

    public static $inject: Array<string> = ["$http", "$translate", "WindowService", "AuthenticationService", "MessageService"];
    constructor(http: ng.IHttpService, $translate: ng.translate.ITranslateService, windowService: WindowService, authService: AuthenticationService, msgService: MessageService) {
		this.$http = http;
		this.$translate = $translate;
		this.windowService = windowService;
        this.authService = authService;
        this.msgService = msgService;
	}

	execute(opt) {

		let _this = this;

		var config = {
			method: opt.method,
			url: opt.url,
			params: opt.params,
			data: opt.data,
			cache: opt.cache || false
		};

		return _this.$http(config)
			.then(function (res) {
				return res;
			}, function (err: ng.IHttpPromiseCallbackArg<IErrorResult>) {
				_this.processErrorResponse(err);
			})
	}

	get(opt) {
		let _this = this;
		return _this.$http.get(opt.url, {
			params: opt.params,
			cache: opt.cache || false
		}).then(function (response) {
			return response;
		}, function (err) {
			_this.processErrorResponse(err);
		});
	}

	private processErrorResponse(response: ng.IHttpPromiseCallbackArg<IErrorResult>) {
		let errorHandled = false;
		if (response && response.data) {
			if (response.data.IsSessionExpired || response.data.IsTokenExpired) {
				errorHandled = true;
				this.authService.logout();
			} else if (isArray(response.data.validationMessages) && response.data.validationMessages.length > 0) {

                let msgList = this.msgService.getLocalisedMessageList(response.data.validationMessages);

				this.windowService.showErrorWindow({
					TextContent: "",
					TextContentList: msgList
				} as IWindowOption);
				errorHandled = true;
			} else if (response.data.message) {
				let $this = this;
				this.windowService.showErrorWindow({
					TextContent: response.data.message,
					EscapeToClose: false,
					OkCallBack: () => {
						if (response.data.ErrorCode == 404) {
							$this.authService.logout();
						}
					}
				} as IWindowOption);

				errorHandled = true;
			}
		}

		if (!errorHandled) {
			throw new Exception(this.$translate.instant("VALIDATION.ERRORINPROCESSING"), true);
		}
	}
}